/* © CNES */
import { filterSections } from '../../../../../assets/config/filters/Referenciel';
import { SelectButtonItem } from '../../../../../models/SelectButtonItem';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { FilterSelectButtons } from '../FilterSelectButtons/FilterSelectButtons';

/**
 * Interface for PlatformCondition Props.
 */
interface PlatformConditionProps {
  platformOptions: SelectButtonItem[] | null;
  handleChange: (e: any, key: string) => void;
}

/**
 * Platform Condition to display other filters depending on platform selection.
 * @param platformOptions all platforms for selected Missions.
 * @param handleChange Function to handle change on platform selection.
 * @returns PlatformCondition Element.
 */
export const PlatformCondition = ({
  platformOptions,
  handleChange,
}: PlatformConditionProps) => {
  /**
   * set new values of platform button select
   * @param value platforms
   */
  const onChangePlatform = (value: string | number[]) => {
    handleChange(value, filterSections.platform.param);
  };

  return (
    <div className="platformFilter">
      <CustomAccordion
        title={filterSections.platform.title}
        children={
          platformOptions && platformOptions.length > 0 ? (
            <FilterSelectButtons
              name={filterSections.platform.param}
              options={platformOptions}
              handleChange={onChangePlatform}
            />
          ) : (
            <div>Please select a mission first.</div>
          )
        }
      />
    </div>
  );
};
